// extracted by mini-css-extract-plugin
export default {"imageContainer":"b2-z","summaryPar":"c2-z","ratingCategories":"d2-z","reviewerInfo":"e2-z","reviewTypes":"f2-z","expanded":"g2-z"};